import { captureException, SeverityLevel } from '@sentry/react';
import { ErrorLogger } from '../logger/logger.interface';

export class MockLogger implements ErrorLogger {
  private groupStyle =
    'color: white; background-color: red; padding: 2px 6px; border-radius: 4px; font-weight: bold;';

  init() {
    console.debug('[MOCK][INIT]');
  }

  captureMessage(message: string, level: SeverityLevel) {
    const styleMap: Record<SeverityLevel, string> = {
      fatal: 'color: white; background: darkred; font-weight: bold;',
      error: 'color: red; font-weight: bold;',
      warning: 'color: orange;',
      log: 'color: gray;',
      info: 'color: cornflowerblue;',
      debug: 'color: green;',
    };

    console.debug(
      `%c[MOCK][CAPTURE MESSAGE][${level.toUpperCase()}]:%c ${message}`,
      styleMap[level],
      'color: inherit;',
    );
  }

  captureException(
    error: unknown,
    context: Parameters<typeof captureException>[1] extends infer L ? L : never,
  ) {
    if (error instanceof Error) {
      const groupTitle = `%c[MOCK][CAPTURE EXCEPTION]: ${error.name}`;

      console.group(groupTitle, this.groupStyle);
      console.debug('%cOriginal error:', 'font-weight: bold;', error);
      console.debug('%cContext:', 'font-weight: bold;', context);
      console.groupEnd();
    } else {
      console.debug({ error });
    }
  }

  setUser(user: { guid: string }) {
    console.debug('[MOCK][SET USER]', user);
  }

  setTag(key: string, value: string) {
    console.debug('[MOCK][SET TAG]', key, value);
  }

  setContext(name: string, context: Record<string, any>) {
    console.debug('[MOCK][SET CONTEXT]', name, context);
  }
}
